export class DialogConfig<D = any> {
	public style?: { [className: string]: any } = {};
	public showClose?: boolean = false;
	public data?: D;
}
